// extracted by mini-css-extract-plugin
export default {"step":"valueAndUnits_step__1isb-","switcher":"valueAndUnits_switcher__Ztc55","value":"valueAndUnits_value__qDyVB","warning":"valueAndUnits_warning__3Pb+C"};